import {deepCopy} from "../../../../stem-core/base/Utils.js";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {apiEditMerchantUserJourney} from "../../../../client/state/merchant/MerchantUserJourneyStore.js";
import {isDeepEqual} from "../../../../blinkpay/UtilsLib.js";
import {SDKResourceEditorState} from "../components/BaseEditorState.js";
import type {MerchantUserJourney} from "../../../../client/state/merchant/MerchantUserJourneyStore";

export class JourneyEditorState extends SDKResourceEditorState {
    // Assigned in the constructor and by load()
    declare journey: MerchantUserJourney;
    declare journeyOptions: Record<string, any>;

    constructor(journey: MerchantUserJourney) {
        super();
        this.journey = journey;
        this.advancedMode = true;
        this.load();
    }

    getInitialDashboardOptions(journey = this.journey) {
        return deepCopy({}, journey.dashboardOptions);
    }

    load(journey = this.journey) {
        this.journeyOptions = deepCopy({}, this.journey.options);
        this.dashboardOptions = this.getInitialDashboardOptions(journey);
    }

    isEdited() {
        return !isDeepEqual(this.dashboardOptions, this.getInitialDashboardOptions())
            || !isDeepEqual(this.journeyOptions, this.journey.options || {});
    }

    @wrapInSpinner
    async saveChanges() {
        this.journey = await apiEditMerchantUserJourney({
            sdkSettingsId: this.journey.settingsVersionId,
            userJourneyId: this.journey.id,
            options: this.journeyOptions,
            dashboardOptions: this.dashboardOptions
        });

        this.discardChanges();
    }
}
